<template>
  <div class="app-container">
    <div class="sec-list" id="box-1">
      <div class="card" style="padding-bottom: 0;">
        <div class="title">涛略公司介绍</div>
        <div class="title-sub mt10 mb10">上海涛略信息技术有限公司是搜狗输入法在信创领域的唯一合作方，即搜狗输入法信创产品中心的运营实体。</div>
        <div class="card" style="padding-top: 10px;">
          <div class="card-item-box flex">
            <div class="card-item" v-for="(item, index) in comItrImgList" :key="index">
              <img v-lazy="item.src" style="width: 487px;" />
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="sec-list" id="box-3">
      <div class="card" style="padding-top: 0">
        <div class="title">联系我们</div>
        <div class="card-item-box flex" style="justify-content: space-around;">
          <div class="card-item" v-for="(item, index) in codeImgList" :key="index">
            <img v-lazy="item.src" style="width: 170px;" />
          </div>
        </div>
        <div class="mt30 font-black">
          您还可以通过邮箱
          <a
            href="mailto:contact@taotics-inc.com"
            style="color: #ff5500"
          >contact@taotics-inc.com</a> 联系我们
        </div>
      </div>
    </div>
  </div>
</template>


<script>
import { comItrImgList, codeImgList } from './const.js'
export default {
  data() {
    return {
      comItrImgList,
      codeImgList
    }
  }
}
</script>
